import React from "react";


const Footer = (props)=>{
    return(
        <React.Fragment>
            <footer className="footer">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-sm-6">
                            {new Date().getFullYear()} © Team.
                        </div>
                        <div className="col-sm-6">
                            <div className="text-sm-end d-none d-sm-block">
                                Design & Develop by Tanzania Police Force Corporation Sole (TPFCS)
                            </div>
                        </div>
                    </div>
                </div>
            </footer>

        </React.Fragment>
    );
};

export default Footer;